module.exports = __webpack_public_path__ + "static/media/80.6e371352.png";